angular
	.module('inputTel.components', [])
	.component('inputTel', {
		templateUrl: 'ng/components/inputTel/inputTel.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			inputPattern: '=',
			formName: '=',
			bindingVariable: '=',
			/** Optional data **/
			inputDisableOn: '<',
			autoInvalid: '@',
			inputRequired: '<'
		},
		controllerAs: 'inputTelCtrl',
		controller: function ($translate, validationService) {

			/** not to loose *this reference **/
			var self = this;

			self.validationService = validationService;

			self.valid = true;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;
				self.autoInvalid = !!self.autoInvalid;



			}

			self.$onChanges = function () {
				console.log('inputTel changed!', self);
			}

			self.errorMsgShown = false;
			self.validationService = validationService;

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
			}

			self.change = function () {
				if (!self.autoInvalid) return;


				if (!validationService.isValidTel(self.bindingVariable)) {
					$("#" + self.inputId).addClass("has-error")

				} else {
					$("#" + self.inputId).removeClass("has-error")

				}
			}

			self.checkTel = function (tel) {
				if (typeof (tel) == 'undefined') {
					self.formName[self.inputName] &&
						self.formName[self.inputName].$setValidity('tel', false);
					self.valid = false;
					return;
				}

				if (tel == '') {
					self.formName && 
					self.formName[self.inputName].$setValidity('tel', false);

					self.valid = false;
					return;

				}

				if (!validationService.isValidTel(tel)) {
					self.formName && 
						self.formName[self.inputName] &&
							self.formName[self.inputName].$setValidity('tel', false);
					self.valid = false;
					return;
				}

				self.formName &&
					self.inputName &&
					self.formName[self.inputName] &&
					self.formName[self.inputName].$setValidity('tel', true);

				self.valid = true;

			}

		}
	});